import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  // Access the current location (URL)
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the very top of the page
    window.scrollTo(0, 0);
  }, [pathname]); // This runs every time the path changes

  return null; // This component doesn't render anything visually
};

export default ScrollToTop;